import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import InfiniteScroll from "react-infinite-scroll-component";
import { showNotification } from "../../utils";
import "react-notifications-component/dist/theme.css";
import "./messageshower.css";
import Api from "../../api"; // Importando la API de notificaciones

const MessageShower = () => {
  const [items, setItems] = useState([]);
  // const navigate = useNavigate(); // Currently not used; kept commented for potential future navigation

  useEffect(() => {
    fetchMoreData();
  }, []);

  const fetchMoreData = async () => {
    try {
      const [globalMessages, userMessages] = await Promise.all([
        Api.Notification.GetMessages(),
        Api.Notification.GetUserMessages(),
      ]);
      
      const allMessages = [...(globalMessages || []), ...(userMessages || [])];
      allMessages.sort((a, b) => new Date(b.date) - new Date(a.date)); // Ordenar por fecha descendente
      
      if (allMessages.length) {
        showNotification("¡Aviso!", "Mensajes cargados", "success");
        setItems(allMessages);
      }
    } catch (error) {
      showNotification("Error", error.message, "warning");
      console.log(error);
    }
  };

  return (
    <>
      <div className="inf_scroll-container">
        <div className="inf_scroll" id="inf_scrollDiv">
          <h1>Notificaciones</h1>
          <InfiniteScroll
            dataLength={items.length}
            next={fetchMoreData}
            hasMore={items.length < 10}
            loader={<h4 className="no-msg">No hay mensajes</h4>}
            scrollableTarget="inf_scrollDiv"
          >
            {items.map((i, index) => {
              const msg = i.message || "";
              const looksLikeHtml = /<[^>]+>/.test(msg);
              let contentNode;
              if (looksLikeHtml) {
                let sanitized = DOMPurify.sanitize(msg);
                try {
                  const container = document.createElement('div');
                  container.innerHTML = sanitized;
                  container.querySelectorAll('a[href]').forEach(a => {
                    const href = a.getAttribute('href') || '';
                    if (!/^(https?:|mailto:|tel:|#|\/)/i.test(href)) {
                      a.setAttribute('href', 'https://' + href.replace(/^\/+/, ''));
                    }
                    if (!a.getAttribute('target')) a.setAttribute('target','_blank');
                    const rel = (a.getAttribute('rel')||'').split(/\s+/).filter(Boolean);
                    if (!rel.includes('noopener')) rel.push('noopener');
                    if (!rel.includes('noreferrer')) rel.push('noreferrer');
                    a.setAttribute('rel', rel.join(' '));
                  });
                  // Ajustes para imagenes: lazy loading y evitar desbordes por atributos fijos
                  container.querySelectorAll('img[src]').forEach(img => {
                    if (!img.getAttribute('alt')) img.setAttribute('alt', 'Imagen');
                    img.setAttribute('loading', 'lazy');
                    img.setAttribute('decoding', 'async');
                    img.removeAttribute('width');
                    img.removeAttribute('height');
                    // No inline styles here; CSS se encarga del tamaño responsivo
                  });
                  sanitized = container.innerHTML;
                } catch(_){}
                contentNode = (
                  <div
                    className="inf_message_html"
                    dangerouslySetInnerHTML={{ __html: sanitized }}
                  />
                );
              } else {
                contentNode = <p>{msg}</p>;
              }
              return (
                <div className="infDiv_scroll" key={index}>
                  {contentNode}
                </div>
              );
            })}
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};

export default MessageShower;